import { connect } from "react-redux";
import { mapStateToHeaderProps, mapDispatchToHeaderProps } from "../mapToProps"; 
import HeaderView from "../views/headerView"

export const HeaderPresenter = connect(
    mapStateToHeaderProps,
    mapDispatchToHeaderProps
)(HeaderView)